import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Sprout, Eye, HeartHandshake } from 'lucide-react';

const pillars = [
  {
    Icon: Sprout,
    title: 'Real farm, not a pledge',
    copy: 'Private 18-acre orchard in Nashik. No carbon-offset abstraction — you can visit the soil.',
  },
  {
    Icon: Eye,
    title: 'Transparent updates',
    copy: 'Seasonal photos, growth journals and farmer notes — arriving quietly, for years.',
  },
  {
    Icon: HeartHandshake,
    title: 'Long-term care',
    copy: 'Year-round watering, pruning and protection. One payment. Decades of tending.',
  },
  {
    Icon: ShieldCheck,
    title: 'Sustainable gifting',
    copy: 'Native species. Zero plastic. Living carbon, edible yield, honest legacy.',
  },
];

export default function Trust() {
  return (
    <section id="trust" className="bg-brand-bg2 py-28 md:py-36" data-testid="trust-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl mb-14">
          <p className="text-brand-gold tracking-[0.25em] uppercase text-xs mb-5 font-medium">Why Pallavit</p>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-brand-ink leading-[1.05] tracking-tight font-light">
            Trusted, because <em className="text-brand-forest">we put our name on it too.</em>
          </h2>
          <p className="mt-5 text-brand-ink2 text-lg leading-relaxed">
            Every tree is traceable to a row, a farmer, and a season. No tokens. No greenwash.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {pillars.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="rounded-3xl border border-brand-line bg-brand-bg p-7 hover:border-brand-gold/60 transition-all duration-500"
              data-testid={`trust-pillar-${i}`}
            >
              <span className="inline-flex w-12 h-12 rounded-2xl bg-brand-forest/10 items-center justify-center text-brand-forest mb-5">
                <p.Icon className="w-5 h-5" strokeWidth={1.75} />
              </span>
              <div className="font-serif text-xl text-brand-ink leading-tight mb-2">{p.title}</div>
              <div className="text-brand-ink2 text-[14.5px] leading-relaxed">{p.copy}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
